import { BlockStack, InlineGrid, InlineStack, Text } from '@shopify/polaris'

import { PartnerCard } from './PartnerCard'
import { PartnerSection } from './partnersData'
import styles from './PartnersPage.module.css'

export const PartnerSectionComponent = ({ section }: { section: PartnerSection }) => (
  <BlockStack gap="400">
    <BlockStack gap="200">
      <InlineStack align="space-between" blockAlign="center">
        <BlockStack gap="100">
          <span className={styles.sectionLabel}>
            <Text variant="bodySm" as="span" tone="subdued" fontWeight="semibold">
              {section.label}
            </Text>
          </span>
          <Text variant="headingLg" as="h2">
            {section.title}
          </Text>
        </BlockStack>
        {section.label === 'CATEGORY' && (
          <Text as="span" tone="subdued">
            {section.apps.length} apps
          </Text>
        )}
      </InlineStack>
      <Text as="p" tone="subdued">
        {section.description}
      </Text>
    </BlockStack>
    <InlineGrid columns={{ xs: 1, sm: 2, md: 2, lg: 4, xl: 4 }} gap="300">
      {section.apps.map((key) => (
        <PartnerCard key={key} appKey={key} />
      ))}
    </InlineGrid>
  </BlockStack>
)
